import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { useInView } from "@/hooks/useReveal";

export default function Services() {
  const [ref, inView] = useInView();
  return (
    <section
      id="szolgaltatasok"
      ref={ref}
      data-testid="services-section"
      className="section bg-grid"
      style={{ background: "var(--ink)", position: "relative" }}
    >
      <div className="site-container" style={{ position: "relative", zIndex: 1 }}>
        <div
          className="serv-head"
          style={{ display: "grid", gridTemplateColumns: "1fr", gap: 28, marginBottom: 48 }}
        >
          <style>{`
            @media (min-width: 900px) {
              .serv-head { grid-template-columns: 1fr 1fr !important; gap: 80px !important; align-items: end !important; }
            }
          `}</style>
          <div className={`reveal ${inView ? "in-view" : ""}`}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
              <span style={{ height: 1, background: "var(--gold)", width: 32 }} />
              <span className="eyebrow" data-testid="services-eyebrow">02 — Munkák</span>
            </div>
            <h2 className="h2" data-testid="services-h2" style={{ margin: 0 }}>
              Öt szakterület, <span style={{ color: "var(--gold)" }}>komolyan véve.</span>
            </h2>
          </div>
          <p className={`lead reveal reveal-1 ${inView ? "in-view" : ""}`} style={{ margin: 0, maxWidth: 460 }} data-testid="services-sub">
            A bádogos munka a szakterületünk — szegélyek, ereszek, kéménybekötések és korcolt lemezfedés. Mellette tetőszerkezet, cseréptető és felújítás is, mindig személyes odafigyeléssel.
          </p>
        </div>

        <div data-testid="services-list">
          {SERVICES.map((s, i) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              data-testid={`service-card-${s.slug}`}
              className={`srv-row reveal reveal-${Math.min(i + 1, 4)} ${inView ? "in-view" : ""}`}
            >
              <span className="srv-num">{s.number}</span>
              <div>
                <h3 className="srv-title">{s.title}</h3>
                <p className="body" style={{ margin: "6px 0 0", maxWidth: 620 }}>
                  {s.summary}
                </p>
              </div>
              <span className="srv-arrow">
                <ArrowUpRight size={20} strokeWidth={1.6} />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
